
export const FETCH_CARER_STUDENTS = 'parentdashboard/FETCH_CARER_STUDENTS';
export const FETCH_CARER_STUDENTS_SUCCESS = 'parentdashboard/FETCH_CARER_STUDENTS_SUCCESS';
export const FETCH_CARER_STUDENTS_FAILED = 'parentdashboard/FETCH_CARER_STUDENTS_FAILED';

export const GET_PLOT_COURSES = 'parentdashboard/GET_PLOT_COURSES';
export const GET_PLOT_COURSES_SUCCESS =
  'parentdashboard/GET_PLOT_COURSES_SUCCESS';
export const GET_PLOT_COURSES_FAILED =
  'parentdashboard/GET_PLOT_COURSES_FAILED';

export const GET_PLOT_TASK = 'parentdashboard/GET_PLOT_TASK';
export const GET_PLOT_TASK_SUCCESS = 'parentdashboard/GET_PLOT_TASK_SUCCESS';
export const GET_PLOT_TASK_FAILED = 'parentdashboard/GET_PLOT_TASK_FAILED';

export const GET_STUDENT_ACADEMIC_REPORT =
  'parentdashboard/GET_STUDENT_ACADEMIC_REPORT';
export const GET_STUDENT_ACADEMIC_REPORT_SUCCESS =
  'parentdashboard/GET_STUDENT_ACADEMIC_REPORT_SUCCESS';
export const GGET_STUDENT_ACADEMIC_REPORT_FAILED =
  'parentdashboard/GGET_STUDENT_ACADEMIC_REPORT_FAILED';

export const GET_STUDENT_ABSENCE_SUMMARY =
  'parentdashboard/GET_STUDENT_ABSENCE_SUMMARY';
export const GET_STUDENT_ABSENCE_SUMMARY_SUCCESS =
  'parentdashboard/GET_STUDENT_ABSENCE_SUMMARY_SUCCESS';
export const GET_STUDENT_ABSENCE_SUMMARY_FAILED =
  'parentdashboard/GET_STUDENT_ABSENCE_SUMMARY_FAILED';

export const GET_STUDENT_LEARNING_BEHAVIOUR =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR';
export const GET_STUDENT_LEARNING_BEHAVIOUR_SUCCESS =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR_SUCCESS';
export const GET_STUDENT_LEARNING_BEHAVIOUR_FAILED =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR_FAILED';

export const GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE';
export const GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_SUCCESS =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_SUCCESS';
export const GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_FAILED =
  'parentdashboard/GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_FAILED';

export const GET_STUDENT_LEARNING_GOALS =
  'parentdashboard/GET_STUDENT_LEARNING_GOALS';
export const GET_STUDENT_LEARNING_GOALS_SUCCESS =
  'parentdashboard/GET_STUDENT_LEARNING_GOALS_SUCCESS';
export const GET_STUDENT_LEARNING_GOALS_FAILED =
  'parentdashboard/GET_STUDENT_LEARNING_GOALS_FAILED';

export const GET_HOME_ROOM_COMMENTS = 'parentdashboard/GET_HOME_ROOM_COMMENTS';
export const GET_HOME_ROOM_COMMENTS_SUCCESS =
  'parentdashboard/GET_HOME_ROOM_COMMENTS_SUCCESS';
export const GET_HOME_ROOM_COMMENTS_FAILED =
  'parentdashboard/GET_HOME_ROOM_COMMENTS_FAILED';

export const GET_STUDENT_LIST = 'parentdashboard/GET_STUDENT_LIST';
export const GET_STUDENT_LIST_SUCCESS = 'parentdashboard/GET_STUDENT_LIST_SUCCESS';
export const GET_STUDENT_LIST_FAIL = 'parentdashboard/GET_STUDENT_LIST_FAIL';


export const FETCH_STUDENT_NOTES = 'parentdashboard/FETCH_STUDENT_NOTES';
export const FETCH_STUDENT_NOTES_SUCCESS = 'parentdashboard/FETCH_STUDENT_NOTES_SUCCESS';
export const FETCH_STUDENT_NOTES_FAIL = 'parentdashboard/FETCH_STUDENT_NOTES_FAIL';

export const SEND_STUDENT_NOTE = 'parentdashboard/SEND_STUDENT_NOTE';
export const SEND_STUDENT_NOTE_SUCCESS = 'parentdashboard/SEND_STUDENT_NOTE_SUCCESS';
export const SEND_STUDENT_NOTE_FAIL = 'parentdashboard/SEND_STUDENT_NOTE_FAIL';

export const APPEND_STUDENT_ARRAY = 'parentdashboard/APPEND_STUDENT_ARRAY'
